
/**
 * This module opens the input text when clicking on the other option in a Select.
 */
export default function showOtherOptionInput() {
	const otherOptions = document.querySelectorAll( '.gfield_checkbox li:last-child' );

	if ( !otherOptions ) {
		return;
	}

	Array.from( otherOptions ).forEach( function doActions( element ) {
		addCheckboxListener( element );
		checkIfToggled( element );
	});

	/**
	 * Adds the on click listener.
	 *
	 * @param {object} element the checkbox element
	 */
	function addCheckboxListener( element ) {
		element.addEventListener( 'change', function activate() {
			toggleInput( element );
		});
	}

	/**
	 * Checks it the checkbox is checked. (When completing the form).
	 *
	 * @param {object} element the checkbox element
	 */
	function checkIfToggled( element ) {
		const isChecked = element.querySelector( 'input' ).checked;
		if ( isChecked ) {
			toggleInput( element );
		}
	}

	/**
	 * Toggles the "other input".
	 *
	 * @param {object} element the checkbox element
	 */
	function toggleInput( element ) {
		const $textInput = getTextInput( '.gfield_visibility_visible', '.other', element );
		$textInput.toggle();
	}

	/**
	 * Finds the corresponding "other" input field.
	 *
	 * @param {object} parentSelector the parent element
	 * @param {object} inputSelector the input element
	 * @param {object} element the element
	 *
	 * @return {object} the element if found.
	 */
	function getTextInput( parentSelector, inputSelector, element ) {
		const $parent = $( element ).closest( parentSelector );
		if ( $parent.length ) {
			return $parent.next( inputSelector );
		}
		return false;
	}
}
